import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Menu } from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";

import { ConfirmationDialog } from "@/components/molecules/ConfirmationDialog";
import { ProductFormData } from "@/components/screens/ProductFormPage/types";
import useDialog from "@/hooks/use-dialog";
import { ISku } from "@/interfaces/sku.interface";
import { SkuFormMessages } from "@/messages/sku/sku-form.messages";
import NotificationItem from "@/mui/Items/NotificationItem";

interface Props {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: SkuFormMessages;
  selectedSku: ISku;
  onRemove: (sku: ISku) => void;
  openDialog: (isEditing: boolean, sku?: ISku) => void;
}

function SkuPopover({
  isOpen,
  anchorEl,
  onClose,
  messages,
  selectedSku,
  onRemove,
  openDialog,
}: Props) {
  const { isVisible, handleOpen, handleClose } = useDialog<ISku>();
  const { setFieldValue } = useFormikContext<ProductFormData>();

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <NotificationItem
        icon={<EditIcon />}
        title={messages.updatePopover}
        onClick={() => {
          openDialog(true);
          setFieldValue("sku", selectedSku);
          onClose();
        }}
      />

      <NotificationItem
        icon={<DeleteIcon />}
        title={messages.removePopover}
        onClick={() => handleOpen()}
      />

      <ConfirmationDialog
        isOpen={isVisible}
        onClose={handleClose}
        onConfirm={() => {
          onRemove(selectedSku);
          handleClose();
        }}
        titleText={messages.deleteSkuDialogTitle}
        descriptionText={messages.deleteSkuDialogContent}
        cancelText={messages.deleteSkuDialogCancel}
        confirmText={messages.deleteSkuDialogConfirm}
        isLoading={false}
      />
    </Menu>
  );
}

export default SkuPopover;
